import React from 'react'
import SchoolList from '../Services/Console/components/Schools/SchoolList'

export default function SchoolListPage() {
  return (
    <SchoolList />
  )
}
